import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import StatusLoginComplete from './StatusLoginComplete';

const mapStateToProps = ({ login }) => ({ oidcClientId: login.oidcClientId });

export default connect(mapStateToProps)(translate()(StatusLoginComplete));
